<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" v-loading="loading" border stripe>
                <el-table-column prop="ip_str" label="IP地址"></el-table-column>
                <el-table-column prop="visit_count" label="访问次数"></el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";
import { getListData } from '@/api/common'

export default {
    name: 'visitLimitInfo',
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.getData()
        },
    },
    data() {
        return {
            model: {
                
            },
            list_url: "/api/admin/visitlimit/visitInfo",
            enu_name: [],
            search_Obj: {},
            showflag: false,
        };
    },
    methods: {
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data;
                }
            })
        },
        closeDialog() {
            this.$emit("on-close")
        },
    }
};
</script>